/* eslint-disable react/prop-types */
import React from 'react';

/**
 * Confidence chip — used everywhere a metric is surfaced.
 *
 * Calm visual language. Never red, never alarm.
 *
 *  - LOW       : <  20 transitions  → stone (neutral, faded)
 *  - EMERGING  : 20–49              → amber-ish (warming up)
 *  - RELIABLE  : 50+                → emerald (trust this number)
 */
const TONE = {
  LOW:      { bg: 'bg-stone-100',   text: 'text-stone-600',   border: 'border-stone-300', dot: 'bg-stone-400' },
  EMERGING: { bg: 'bg-amber-50',    text: 'text-amber-800',   border: 'border-amber-300', dot: 'bg-amber-500' },
  RELIABLE: { bg: 'bg-emerald-50',  text: 'text-emerald-800', border: 'border-emerald-300', dot: 'bg-emerald-600' },
};

const SHORT_LABEL = {
  LOW:      'Insufficient signal',
  EMERGING: 'Emerging',
  RELIABLE: 'Reliable',
};

export default function ConfidenceChip({ code, label, sample, compact = false }) {
  const c = code || 'LOW';
  const tone = TONE[c] || TONE.LOW;
  const text = compact ? SHORT_LABEL[c] : (label || SHORT_LABEL[c]);
  return (
    <span
      data-testid={`confidence-chip-${c}`}
      title={sample !== undefined ? `${sample} transition${sample === 1 ? '' : 's'}` : undefined}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] uppercase tracking-[0.14em] font-['Work_Sans'] ${tone.bg} ${tone.text} ${tone.border}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${tone.dot}`} />
      {text}
      {sample !== undefined && !compact && (
        <span className="opacity-60 normal-case tracking-normal">· {sample}</span>
      )}
    </span>
  );
}
